require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.array.some");

require("core-js/modules/es.array.splice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.number.to-fixed");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.for-each");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "vant/es/dialog/style", "vant/es/dialog", "@/mock/tgjRsaPlatform", "@/utils/ajax"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("vant/es/dialog/style"), require("vant/es/dialog"), require("@/mock/tgjRsaPlatform"), require("@/utils/ajax"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.style, global.dialog, global.tgjRsaPlatform, global.ajax);
    global.tgjRasPlatform = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _style, _dialog, mockJson, _ajax) {
  "use strict";

  var _interopRequireWildcard = require("/root/deploy/iot-gov-report/node_modules/@babel/runtime/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("/root/deploy/iot-gov-report/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _dialog = _interopRequireDefault(_dialog);
  mockJson = _interopRequireWildcard(mockJson);
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  // 桶排列参数
  // 同行爬升斜率
  var BARREL_SLOPE = 0.3;
  var BARREL_LAYOUT = {
    // 同行相邻桶的横向步进
    colStepX: 2.4,
    // 换行向右偏移
    rowShiftX: 1.36,
    // 换行向下偏移
    rowShiftY: 1.55,
    // 1号桶起始位置
    baseX: 1.09,
    baseY: 2.93,
    // 信息卡高出圆筒上沿的距离
    cardOverTop: 0.86
  };
  var BARREL_TILE = {
    // 桶图宽高
    w: 4.5,
    h: 4.5 * 446 / 1038,
    // 桶图相对项盒的偏移
    offX: -0.92,
    offY: 0.29
  };
  var BARREL_CENTER_OFFSET = {
    // 整组居中位置微调，x 往左为负、y 往下为正
    x: 0,
    y: 1.5
  }; // 大棚排列参数

  var GREENHOUSE_LAYOUT = {
    // 单个棚图宽高
    itemW: 3.74,
    itemH: 1.9,
    // 1号棚起始位置
    baseX: 3.59,
    baseY: 0.3,
    // 同行相邻棚的步进
    stepX: 1.45,
    stepY: 0.43,
    // 换排偏移
    rowShiftX: -2.6,
    rowShiftY: 1.7,
    // 名称在棚图内的偏移
    nameOffsetX: 1.35,
    nameOffsetY: 0.53
  }; // 中列面板尺寸

  var PANEL_SIZE = {
    w: 12.2,
    h: 5.3
  };
  var _default = {
    name: "TgjRasPlatform",
    data: function data() {
      return {
        ossHost: this.$config.base.ossHost,
        // 大棚列表与当前选中大棚
        regionList: [],
        selectRegionId: -1,
        rasAreaDetail: {},
        barrels: [],
        // 当前选中的桶（-1=未选中）
        selectBarrelIndex: -1,
        // 中间区域内外层切换 / 大棚管理
        isShowAreaDetail: false,
        isShowManagePanel: false,
        managePage: 1,
        isShowGreenhouseModal: false,
        greenhouseModal: {
          mode: 'add',
          rasAreaId: 0,
          value: ''
        },
        // 设备列表（右列）
        ctrlList: [],
        // 设备弹窗相关（沿用原逻辑）
        isShowModal: false,
        isShowEditModal: false,
        curOpenModalBindDevices: {},
        clickRegionId: -1,
        clickRegionDeviceType: -1,
        deviceInfo: {},
        editIndex: -1,
        isShowWorkTypeList: false,
        deviceSettingInfo: {},
        isShowSettingList: false,
        // 水位告警值设置弹框
        isShowWLValModal: false,
        wlValField: 'high',
        wlValInput: '',
        // 是否网络异常
        isNetError: false,
        // 设备列表分页（每页5台）
        devicePage: 1,
        // 基地id（取自路由 /ent/tgjRas/:id）
        rasId: 0,
        // 基地信息 / 风险预警 / 底部统计
        rasInfo: {},
        riskList: [],
        energyFeed: {},
        energyChart: null
      };
    },
    computed: {
      currentAreaName: function currentAreaName() {
        var _this = this;

        var area = this.regionList.find(function (item) {
          return item.rasAreaId === _this.selectRegionId;
        });
        return area ? area.name : '';
      },
      baseInfoList: function baseInfoList() {
        var info = this.rasInfo || {};
        return [{
          icon: 1,
          label: '养殖鱼种',
          value: info.fishType || '--',
          unit: ''
        }, {
          icon: 2,
          label: '圆桶数量',
          value: info.barrels || 0,
          unit: '个'
        }, {
          icon: 3,
          label: '养殖总水量',
          value: info.waterVolume || 0,
          unit: 'm³'
        }, {
          icon: 3,
          label: '养殖密度',
          value: info.farmingDensity || 0,
          unit: 'kg/m³'
        }, {
          icon: 5,
          label: '管理员数',
          value: info.workerCount || 0,
          unit: '人'
        }, {
          icon: 4,
          label: '智能设备数',
          value: info.deviceCount || 0,
          unit: '台'
        }];
      },
      // 大棚整组居中偏移
      greenhouseOffset: function greenhouseOffset() {
        var L = GREENHOUSE_LAYOUT;
        var n = this.regionList.length;
        if (!n) return {
          dx: 0,
          dy: 0
        };
        var minX = Infinity,
            maxX = -Infinity,
            minY = Infinity,
            maxY = -Infinity;

        for (var i = 0; i < n; i += 1) {
          var col = i % 4;
          var row = Math.floor(i / 4);
          var x = L.baseX + col * L.stepX + row * L.rowShiftX;
          var y = L.baseY + col * L.stepY + row * L.rowShiftY;
          minX = Math.min(minX, x);
          maxX = Math.max(maxX, x + L.itemW);
          minY = Math.min(minY, y);
          maxY = Math.max(maxY, y + L.itemH);
        }

        return {
          dx: PANEL_SIZE.w / 2 - (minX + maxX) / 2,
          dy: PANEL_SIZE.h / 2 - (minY + maxY) / 2
        };
      },
      // 桶整组居中偏移
      barrelOffset: function barrelOffset() {
        var n = this.barrels.length;
        if (!n) return {
          dx: 0,
          dy: 0
        };
        var minX = Infinity,
            maxX = -Infinity,
            minY = Infinity,
            maxY = -Infinity;

        for (var i = 0; i < n; i += 1) {
          var _this$barrelSlotPos = this.barrelSlotPos(i),
              x = _this$barrelSlotPos.x,
              y = _this$barrelSlotPos.y;

          minX = Math.min(minX, x + BARREL_TILE.offX);
          maxX = Math.max(maxX, x + BARREL_TILE.offX + BARREL_TILE.w);
          minY = Math.min(minY, y + BARREL_TILE.offY);
          maxY = Math.max(maxY, y + BARREL_TILE.offY + BARREL_TILE.h);
        }

        return {
          dx: PANEL_SIZE.w / 2 + BARREL_CENTER_OFFSET.x - (minX + maxX) / 2,
          dy: PANEL_SIZE.h / 2 + BARREL_CENTER_OFFSET.y - (minY + maxY) / 2
        };
      },
      // 大棚管理弹框：总页数（每页 6 张）
      managePageCount: function managePageCount() {
        return Math.ceil(this.regionList.length / 6) || 1;
      },
      // 大棚管理弹框：当前页的大棚
      pagedRegionList: function pagedRegionList() {
        var start = (this.managePage - 1) * 6;
        return this.regionList.slice(start, start + 6);
      },
      // 溶氧设备列表中是否有 22 版本小方帽（支持水位告警配置）
      hasCbmWLDevice: function hasCbmWLDevice() {
        var list = this.curOpenModalBindDevices.deviceViews || [];
        return list.some(function (item) {
          return item.type == 22;
        });
      },
      // 设备列表分页：每页5台
      devicePageCount: function devicePageCount() {
        return Math.ceil((this.curOpenModalBindDevices.deviceViews || []).length / 5) || 1;
      },
      // 当前页码兜底
      safeDevicePage: function safeDevicePage() {
        return Math.min(this.devicePage, this.devicePageCount);
      },
      // 当前页第一台设备在完整列表中的下标
      devicePageOffset: function devicePageOffset() {
        return (this.safeDevicePage - 1) * 5;
      },
      // 当前页的设备列表
      pagedDeviceViews: function pagedDeviceViews() {
        var list = this.curOpenModalBindDevices.deviceViews || [];
        var start = this.devicePageOffset;
        return list.slice(start, start + 5);
      }
    },
    created: function created() {
      var vm = this; // 基地id：取自路由 /ent/tgjRas/:id（异常值兜底为1）

      vm.rasId = Number(vm.$route.params.id) || 1; // 是否读取本地mock数据（默认走真实接口）

      vm.__MOCK_STATUS = false;
      window.onresize = getRem;

      function getRem() {
        document.getElementById('root').style.fontSize = document.documentElement.offsetWidth / 19.5 + 'px';
      }

      getRem(); // 接口异常改用顶部提示

      _ajax.netError.banner = true;

      _ajax.netError.listeners.push(vm.onNetErrorChange);

      vm.init();
      vm.loadEnergyFeed(); // 10s一次轮询

      setInterval(vm.init, 10000);
    },
    mounted: function mounted() {
      var _this2 = this;

      // 添加 resize 事件监听器
      window.addEventListener('resize', this.handleResize); // 确保图表在 DOM 就绪后初始化

      this.$nextTick(function () {
        _this2.initEnergyChart();
      });
    },
    beforeDestroy: function beforeDestroy() {
      // 移除 resize 事件监听器
      window.removeEventListener('resize', this.handleResize); // 还原默认弹窗行为

      _ajax.netError.banner = false;
      _ajax.netError.value = false;

      var index = _ajax.netError.listeners.indexOf(this.onNetErrorChange);

      index > -1 && _ajax.netError.listeners.splice(index, 1);
    },
    methods: {
      init: function init() {
        var vm = this; // 获取大棚（区域）列表信息

        vm.loadRegionList(); // 获取循环水概览

        vm.loadRasInfo(); // 风险预警（随轮询刷新）

        vm.loadRiskList(); // 底部统计（随轮询刷新）

        vm.loadEnergyStatistic();
      },
      // 获取大棚（区域）列表
      loadRegionList: function loadRegionList() {
        var vm = this;

        if (vm.__MOCK_STATUS) {
          vm.regionList = [].concat(mockJson.rasAreasJson);

          if (!(vm.selectRegionId > -1) && vm.regionList.length) {
            vm.selectRegionId = vm.regionList[0].rasAreaId;
          } // 内层刷新详情，列表层重建总览


          if (vm.isShowAreaDetail) {
            vm.loadRegionInfo();
          } else {
            vm.formateCtrlList();
          }

          return;
        }

        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasAreas?rasId=").concat(vm.rasId),
          except: true
        }).then(function (res) {
          if (res.code == 1) {
            vm.regionList = [].concat(res.data);

            if (!(vm.selectRegionId > -1) && vm.regionList.length) {
              vm.selectRegionId = vm.regionList[0].rasAreaId;
            } // 内层刷新详情，列表层重建总览


            if (vm.isShowAreaDetail) {
              vm.loadRegionInfo();
            } else {
              vm.formateCtrlList();
            }
          }
        }).catch(function (err) {
          console.log(err);
        });
      },
      // 获取循环水概览
      loadRasInfo: function loadRasInfo() {
        var vm = this;

        if (vm.__MOCK_STATUS) {
          vm.rasInfo = vm.$strTool.copy(mockJson.rasInfoJson); // 圆桶数量按各棚实际桶数合计

          var barrelTotal = 0;
          Object.keys(mockJson.rasAreaDetailMap).forEach(function (key) {
            (mockJson.rasAreaDetailMap[key].policyDeviceViews || []).map(function (item) {
              item.type == 8 && (barrelTotal += (item.deviceViews || []).length);
            });
          });
          vm.rasInfo.barrels = barrelTotal;
          return;
        }

        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasInfo?rasId=").concat(vm.rasId),
          except: true
        }).then(function (res) {
          if (res.code == 1) {
            vm.rasInfo = res.data;
          }
        }).catch(function (err) {
          console.log(err);
        });
      },
      // 风险预警：接口 faults（mock 模式用本地数据）
      loadRiskList: function loadRiskList() {
        var vm = this;

        if (vm.__MOCK_STATUS) {
          vm.riskList = vm.$strTool.copy(mockJson.riskWarnJson);
          return;
        }

        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasInfo/").concat(vm.rasId, "/faults"),
          except: true
        }).then(function (res) {
          if (res.code == 1 && res.data) {
            vm.riskList = res.data.map(function (item) {
              return {
                key: "".concat(item.iotDeviceId, "-").concat(item.warningAt),
                // 分组名与设备名连写，如 2区1号桶
                text: "".concat(item.rasAreaName || '').concat(item.name || '', " ").concat(vm.warnTypeText(item.warningType)),
                time: vm.fmtFaultTime(item.warningAt),
                unread: item.remindStatus == 0
              };
            });
          }
        }).catch(function (err) {
          console.log(err);
        });
      },
      // 底部三卡统计：接口 statistic（随轮询刷新，mock 模式用本地数据）
      loadEnergyStatistic: function loadEnergyStatistic() {
        var vm = this;

        if (vm.__MOCK_STATUS) {
          vm.energyFeed = Object.assign({}, vm.energyFeed, {
            abnormalBarrelCount: mockJson.energyFeedJson.abnormalBarrelCount,
            todayElectricity: mockJson.energyFeedJson.todayElectricity,
            todayFeed: mockJson.energyFeedJson.todayFeed
          });
          return;
        }

        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasInfo/").concat(vm.rasId, "/statistic"),
          except: true
        }).then(function (res) {
          if (res.code == 1 && res.data) {
            vm.energyFeed = Object.assign({}, vm.energyFeed, {
              abnormalBarrelCount: res.data.abnormalColumnCount || 0,
              // 用电量 0.01kWh → 度
              todayElectricity: Number(((res.data.todayUseEnergy || 0) / 100).toFixed(1)),
              // 投料量 克 → 斤
              todayFeed: Number(((res.data.todayFeedWeight || 0) / 500).toFixed(1))
            });
          }
        }).catch(function (err) {
          console.log(err);
        });
      },
      // 每日投料/用电曲线：接口 daily/statistic（取最近25天，mock 模式用本地数据）
      loadEnergyFeed: function loadEnergyFeed() {
        var vm = this;

        if (vm.__MOCK_STATUS) {
          vm.energyFeed = vm.$strTool.copy(mockJson.energyFeedJson);
          vm.$nextTick(function () {
            vm.initEnergyChart();
          });
          return;
        }

        var end = new Date();
        var start = new Date(end.getTime() - 24 * 24 * 3600 * 1000);
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasInfo/").concat(vm.rasId, "/daily/statistic?startDate=").concat(vm.fmtDate(start), "&endDate=").concat(vm.fmtDate(end)),
          except: true
        }).then(function (res) {
          if (res.code == 1 && res.data) {
            // 接口返回未排序，先按日期升序再取数
            var list = [].concat(res.data).sort(function (a, b) {
              return a.date.localeCompare(b.date);
            });
            vm.energyFeed = Object.assign({}, vm.energyFeed, {
              days: list.map(function (item) {
                return item.date.slice(8, 10);
              }),
              // 投料量 克 → 斤
              feedData: list.map(function (item) {
                return Number(((item.feedWeight || 0) / 500).toFixed(1));
              }),
              // 用电量 0.01kWh → 度
              electricityData: list.map(function (item) {
                return Number(((item.useEnergy || 0) / 100).toFixed(1));
              })
            });
            vm.$nextTick(function () {
              vm.initEnergyChart();
            });
          }
        }).catch(function (err) {
          console.log(err);
        });
      },
      // 格式化日期为 yyyy-MM-dd（每日统计查询用）
      fmtDate: function fmtDate(date) {
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        var d = date.getDate();
        return "".concat(y, "-").concat(m > 9 ? m : '0' + m, "-").concat(d > 9 ? d : '0' + d);
      },
      // 告警类型文案（warningList 对照表）
      warnTypeText: function warnTypeText(warningType) {
        var map = {
          1: '过载',
          2: '电流不平衡',
          3: '意外停机',
          4: '过压',
          5: '欠压',
          6: '相序错误',
          7: '断电',
          8: '进线电压不一致',
          9: '支路电压不一致',
          10: '继电器异常',
          11: '温度过高',
          31: '失联',
          32: '请求超时',
          33: '断电重启',
          34: '设备过期',
          35: '未绑定池塘',
          36: '电流过低',
          37: '断电异常停机',
          38: '硬件复位异常停机',
          39: '过载异常停机',
          40: '过压异常停机',
          41: '拉闸异常停机',
          42: '定时未开启',
          43: '定时开启电流为0',
          45: '进线缺相',
          50: '电机卡壳',
          51: '无料停机',
          54: '投料异常',
          55: '电压过低停机',
          56: '电压过低停机',
          70: '溶氧过低',
          71: '探头受污染',
          72: '设备需要维护',
          73: '管道堵塞',
          74: '测量受到干扰',
          75: '长时间未上报溶氧',
          76: '设备故障',
          77: '探头泡水',
          78: '管道漏气',
          79: '探头受污染',
          81: '设备倾斜',
          82: '自动开机失败',
          83: '测量结果异常',
          84: '溶氧全天无明显波动',
          85: '溶氧趋势异常',
          86: '液位过低',
          87: '液位过高',
          88: '气压过低',
          118: '增氧机定时关机失败',
          119: '增氧机人为按键关闭',
          120: '摄像机人形移动报警'
        };
        return map[warningType] || '设备异常';
      },
      // 告警时间文案：M/D HH:mm
      fmtFaultTime: function fmtFaultTime(ts) {
        if (!ts) return '';
        var d = new Date(ts);
        return "".concat(d.getMonth() + 1, "/").concat(d.getDate(), " ").concat(this.$time.getHoursMin(d));
      },
      // 获取大棚详情：deviceType 为空则更新页面信息
      loadRegionInfo: function loadRegionInfo(deviceType, regionId) {
        var vm = this;

        if (vm.__MOCK_STATUS) {
          var detail = mockJson.rasAreaDetailMap[regionId || vm.selectRegionId];
          var data = vm.$strTool.copy(detail || {});

          if (Number(deviceType)) {
            vm.deviceInfo.type = deviceType;
            vm.curOpenModalBindDevices = vm.$strTool.copy((data.policyDeviceViews || []).filter(function (item) {
              return item.type == deviceType;
            })[0] || {});
            vm.isShowModal = true;
            return;
          }

          vm.rasAreaDetail = data;
          vm.formateCtrlList();
          vm.formatBarrels();
          return;
        }

        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasAreaDetail?areaId=").concat(regionId || vm.selectRegionId),
          except: true
        }).then(function (res) {
          if (res.code == 1) {
            if (Number(deviceType)) {
              vm.deviceInfo.type = deviceType; // 溶氧仪策略按圆桶多条，合并为一个设备列表

              var groups = res.data.policyDeviceViews.filter(function (item) {
                item.name = vm.$strTool.filterSwitchType(item.type);
                return item.type == deviceType;
              });
              var deviceViews = groups.reduce(function (list, item) {
                return list.concat(item.deviceViews || []);
              }, []);
              vm.curOpenModalBindDevices = {
                type: deviceType,
                name: vm.$strTool.filterSwitchType(deviceType),
                devCount: deviceViews.length,
                runningCount: groups.reduce(function (total, item) {
                  return total + (item.runningCount || 0);
                }, 0),
                waitCount: groups.reduce(function (total, item) {
                  return total + (item.waitCount || 0);
                }, 0),
                warnCount: groups.reduce(function (total, item) {
                  return total + (item.warnCount || 0);
                }, 0),
                deviceViews: deviceViews
              };
              vm.isShowModal = true;
            } else {
              vm.rasAreaDetail = res.data;
              vm.formateCtrlList();
              vm.formatBarrels();
            }
          }
        }).catch(function (err) {
          console.log(err);
        });
      },
      // 提取当前大棚的圆桶
      formatBarrels: function formatBarrels() {
        var vm = this;

        if (vm.__MOCK_STATUS) {
          // mock：桶 = type=8 溶氧仪设备
          var barrels = [];
          (vm.rasAreaDetail.policyDeviceViews || []).map(function (item) {
            item.type == 8 && (barrels = item.deviceViews || []);
          });
          vm.barrels = barrels;
          return;
        } // 圆桶告警来自 type=8 策略


        var warnMap = {};
        (vm.rasAreaDetail.policyDeviceViews || []).forEach(function (item) {
          if (item.type == 8 && item.rasColumnId != null) {
            warnMap[item.rasColumnId] = (item.deviceViews || []).some(function (dev) {
              return dev.warningType > 0;
            }) ? 1 : 0;
          }
        });
        vm.barrels = (vm.rasAreaDetail.columnViews || []).map(function (column) {
          var device = (column.deviceViews || [])[0] || {};
          return {
            columnId: column.id,
            name: column.name,
            dissolvedOxygen: device.dissolvedOxygen != null ? device.dissolvedOxygen : null,
            // 当前水深，单位 m
            depth: device.cbmWaterLevel != null ? device.cbmWaterLevel : null,
            // 仅 sku=22 的小方帽设备展示液位
            showDepth: device.type == 22,
            warningType: warnMap[column.id] || 0
          };
        });
      },
      // 开关列表按设计稿顺序
      // [投料机、循环泵、蛋白分离器、臭氧机、氧气锥、紫外线杀菌、热泵、过滤鼓风机、微滤机]
      // 外层总览，内层当前大棚
      formateCtrlList: function formateCtrlList() {
        var vm = this;
        var ctrlList = [{
          type: 9,
          name: '投料机'
        }, {
          type: 0,
          name: '循环泵'
        }, {
          type: 1,
          name: '蛋白分离器'
        }, {
          type: 2,
          name: '臭氧机'
        }, {
          type: 3,
          name: '氧气锥'
        }, {
          type: 4,
          name: '紫外线杀菌'
        }, {
          type: 5,
          name: '热泵'
        }, {
          type: 6,
          name: '过滤鼓风机'
        }, {
          type: 7,
          name: '微滤机'
        }];

        if (!vm.isShowAreaDetail) {
          var totals = [];

          if (vm.__MOCK_STATUS) {
            // mock：汇总全部大棚的设备台数
            var overview = {};
            Object.keys(mockJson.rasAreaDetailMap).forEach(function (key) {
              (mockJson.rasAreaDetailMap[key].policyDeviceViews || []).forEach(function (item) {
                if (item.type > 7) return;
                var g = overview[item.type] || (overview[item.type] = {
                  devCount: 0,
                  runningCount: 0,
                  waitCount: 0,
                  warnCount: 0
                });
                g.devCount += item.devCount || 0;
                g.runningCount += item.runningCount || 0;
                g.waitCount += item.waitCount || 0;
                g.warnCount += item.warnCount || 0;
              });
            });
            Object.keys(overview).forEach(function (type) {
              totals.push(Object.assign({
                type: Number(type)
              }, overview[type]));
            });
          } else {
            // 接口返回的全基地按类型汇总（各分组同值，取第一条）
            totals = (vm.regionList[0] || {}).totalPolicyDeviceViews || [];
          }

          totals.forEach(function (item) {
            var row = ctrlList.find(function (ctl) {
              return ctl.type == item.type;
            });
            if (!row) return;

            if (vm.__MOCK_STATUS) {
              Object.assign(row, item);
              return;
            } // 由设备状态现算 正常/待机/异常


            var runningCount = 0;
            var waitCount = 0;
            var warnCount = 0;
            (item.deviceViews || []).forEach(function (dev) {
              if (dev.warningType > 0) {
                warnCount += 1;
              } else if (dev.status == 0) {
                waitCount += 1;
              } else {
                runningCount += 1;
              }
            });
            Object.assign(row, {
              devCount: item.devCount || 0,
              runningCount: runningCount,
              waitCount: waitCount,
              warnCount: warnCount
            });
          });
        } else if (vm.rasAreaDetail && (vm.rasAreaDetail.policyDeviceViews || []).length) {
          // 按类型匹配行，接口计数并入
          vm.rasAreaDetail.policyDeviceViews.forEach(function (item) {
            var row = ctrlList.find(function (ctl) {
              return ctl.type == item.type;
            });
            row && Object.assign(row, item, {
              name: row.name
            });
          });
        }

        vm.ctrlList = ctrlList;
      },
      // 网络异常状态变化
      onNetErrorChange: function onNetErrorChange(value) {
        this.isNetError = value;
      },
      // ==================== 大棚（外层）交互 ====================
      // 悬停选中大棚
      onHoverArea: function onHoverArea(area) {
        var vm = this;
        if (vm.selectRegionId === area.rasAreaId) return;
        vm.selectRegionId = area.rasAreaId;
      },
      // 点击进入大棚（内层圆桶页）
      enterArea: function enterArea(area) {
        var vm = this;
        vm.selectRegionId = area.rasAreaId;
        vm.selectBarrelIndex = -1;
        vm.isShowManagePanel = false; // 先切到内层，再加载详情（右列设备列表按当前层级取数）

        vm.isShowAreaDetail = true;
        vm.loadRegionInfo();
      },
      // 返回外层大棚列表
      backToHome: function backToHome() {
        var vm = this;
        vm.selectBarrelIndex = -1;
        vm.isShowManagePanel = false;
        vm.isShowAreaDetail = false;
        vm.formateCtrlList();
      },
      // 大棚排列基准点（棚图与名称共用；含整组居中偏移）
      greenhousePos: function greenhousePos(index) {
        var col = index % 4;
        var row = Math.floor(index / 4);
        var L = GREENHOUSE_LAYOUT;
        var _this$greenhouseOffse = this.greenhouseOffset,
            dx = _this$greenhouseOffse.dx,
            dy = _this$greenhouseOffse.dy;
        return {
          x: L.baseX + col * L.stepX + row * L.rowShiftX + dx,
          y: L.baseY + col * L.stepY + row * L.rowShiftY + dy
        };
      },
      // 大棚排列位置（同行沿斜向拼接，换排向左下错位；整组按数量自动居中）
      getGreenhouseStyle: function getGreenhouseStyle(index) {
        var _this$greenhousePos = this.greenhousePos(index),
            x = _this$greenhousePos.x,
            y = _this$greenhousePos.y;

        return {
          left: "".concat(x.toFixed(2), "rem"),
          top: "".concat(y.toFixed(2), "rem")
        };
      },
      // 大棚名称位置（与对应棚同基准点，再叠加名称在棚图内的偏移）
      getGreenhouseNameStyle: function getGreenhouseNameStyle(index) {
        var _this$greenhousePos2 = this.greenhousePos(index),
            x = _this$greenhousePos2.x,
            y = _this$greenhousePos2.y;

        var nameOffsetX = GREENHOUSE_LAYOUT.nameOffsetX,
            nameOffsetY = GREENHOUSE_LAYOUT.nameOffsetY;
        return {
          left: "".concat((x + nameOffsetX).toFixed(2), "rem"),
          top: "".concat((y + nameOffsetY).toFixed(2), "rem")
        };
      },
      // 桶按行分组，行内从右往左、下一行在后
      barrelRowIndexes: function barrelRowIndexes() {
        var n = this.barrels.length;
        var rows = [];

        for (var rowStart = 0; rowStart < n; rowStart += 4) {
          var rowEnd = Math.min(rowStart + 4, n);
          var rowIndexes = [];

          for (var i = rowEnd - 1; i >= rowStart; i -= 1) {
            rowIndexes.push(i);
          }

          rows.push(rowIndexes);
        }

        return rows;
      },
      // 桶位，圆筒锚点
      barrelSlotPos: function barrelSlotPos(index) {
        var L = BARREL_LAYOUT;
        var colStepY = -L.colStepX * BARREL_SLOPE;
        var row = Math.floor(index / 4);
        var col = index % 4;
        return {
          x: L.baseX + col * L.colStepX + row * L.rowShiftX,
          y: L.baseY + col * colStepY + row * (colStepY + L.rowShiftY)
        };
      },
      getBarrelSlotStyle: function getBarrelSlotStyle(index) {
        var _this$barrelSlotPos2 = this.barrelSlotPos(index),
            x = _this$barrelSlotPos2.x,
            y = _this$barrelSlotPos2.y;

        var _this$barrelOffset = this.barrelOffset,
            dx = _this$barrelOffset.dx,
            dy = _this$barrelOffset.dy; // 项盒顶部对齐卡片顶部

        return {
          left: "".concat((x + dx).toFixed(2), "rem"),
          top: "".concat((y - BARREL_LAYOUT.cardOverTop + dy).toFixed(2), "rem")
        };
      },
      // 打开分组管理弹框
      openManagePanel: function openManagePanel() {
        if (this.isShowAreaDetail) return;
        this.managePage = 1;
        this.isShowManagePanel = true;
      },
      // 打开新建/重命名大棚弹框
      openGreenhouseModal: function openGreenhouseModal(mode, area) {
        this.greenhouseModal = {
          mode: mode,
          rasAreaId: area ? area.rasAreaId : 0,
          value: area ? area.name : ''
        };
        this.isShowGreenhouseModal = true;
      },
      // 保存大棚（新增 / 重命名）
      saveGreenhouse: function saveGreenhouse() {
        var vm = this;
        var name = (vm.greenhouseModal.value || '').trim();

        if (!name) {
          _dialog.default.alert({
            title: '提示',
            message: '请输入大棚名称'
          });

          return;
        }

        if (vm.__MOCK_STATUS) {
          // 本地 mock：直接改本地数据
          if (vm.greenhouseModal.mode === 'edit') {
            var area = mockJson.rasAreasJson.find(function (item) {
              return item.rasAreaId === vm.greenhouseModal.rasAreaId;
            });
            area && (area.name = name);

            if (area && mockJson.rasAreaDetailMap[area.rasAreaId]) {
              mockJson.rasAreaDetailMap[area.rasAreaId].name = name;
            }
          } else {
            var maxId = mockJson.rasAreasJson.reduce(function (max, item) {
              return Math.max(max, item.rasAreaId);
            }, 0);
            var newArea = {
              rasAreaId: maxId + 1,
              name: name,
              dissolvedOxygen: 0,
              temperature: 0,
              ph: 0,
              depth: 0,
              ryDeviceCount: 0,
              ryWarningType: 0
            };
            mockJson.rasAreasJson.push(newArea);
            mockJson.rasAreaDetailMap[newArea.rasAreaId] = mockJson.createAreaDetail(newArea.rasAreaId, name);
            vm.selectRegionId = newArea.rasAreaId;
          }

          vm.isShowGreenhouseModal = false;
          vm.isShowManagePanel = false;
          vm.init();

          _dialog.default.alert({
            title: '',
            message: '保存成功'
          });

          return;
        } // 重命名 / 新建大棚


        var isEdit = vm.greenhouseModal.mode === 'edit';
        var request = isEdit ? vm.$http({
          type: "put",
          url: "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasArea/").concat(vm.greenhouseModal.rasAreaId),
          data: {
            name: name
          }
        }) : vm.$http({
          type: "post",
          url: "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasArea"),
          data: {
            name: name,
            rasId: vm.rasId
          }
        });
        request.then(function (res) {
          if (res.code == 1) {
            vm.isShowGreenhouseModal = false;
            vm.isShowManagePanel = false;
            vm.init();

            _dialog.default.alert({
              title: '',
              message: '保存成功'
            });
          }
        }).catch(function (err) {
          console.log(err);
        });
      },
      // 片区详情：添加桶（= 添加一个溶氧仪）
      addBarrel: function addBarrel() {
        var vm = this;
        vm.clickRegionId = vm.selectRegionId;
        vm.clickRegionDeviceType = 8;
        vm.deviceInfo = {
          type: 8
        };
        vm.isShowEditModal = true;
      },
      // 片区详情：管理桶（= 管理溶氧仪设备）
      manageBarrels: function manageBarrels() {
        var vm = this;
        if (!vm.barrels.length) return;
        vm.bindRyDevice(null, vm.selectRegionId);
      },
      // 片区详情：点击选择圆桶（选中效果）
      selectBarrel: function selectBarrel(index) {
        this.selectBarrelIndex = index;
      },
      // 右侧设备行点击：总览模式仅展示，大棚内可添加、管理设备
      onDeviceRowClick: function onDeviceRowClick(item) {
        var vm = this; // 总览模式不提供操作入口

        if (!vm.isShowAreaDetail) {
          return;
        }

        if (!item.devCount) {
          vm.addDevice(vm.selectRegionId, item.type);
          return;
        }

        vm.bindRyDevice(item, vm.selectRegionId);
      },
      // ==================== 设备相关（沿用原逻辑） ====================
      // 编辑区域的设备绑定关系
      // 设备类型 0.循环泵 1.蛋白分离器 2.臭氧机 3.氧气锥 4.紫外线杀菌 5.热泵 6.过滤鼓风机 7.微滤机 8.溶氧检测仪
      bindRyDevice: function bindRyDevice(deviceItem, regionId) {
        var vm = this; // 重置设备列表分页

        vm.devicePage = 1; // 点击溶氧监控设备编辑的时候需要再次获取区域详情

        if (!(deviceItem && deviceItem.type > -1)) {
          // 点击溶氧监控设备查看详情，如果当前点击的为非当前暂时的区域需要重新获取区域详情展示
          vm.loadRegionInfo(8, regionId);
        } else {
          vm.isShowModal = true;
          vm.curOpenModalBindDevices = vm.$strTool.copy(deviceItem);
        }

        vm.clickRegionId = regionId;
        vm.loadDeviceSetting(deviceItem ? 0 : 8, regionId);
        vm.clickRegionDeviceType = deviceItem ? deviceItem.type : 8;
      },
      // 新绑定设备，如果是type=8新增溶氧设备的话需要记录当前地区ID以便后面绑定
      addDevice: function addDevice(regionId, type) {
        var vm = this;
        vm.devicePage = 1;
        vm.clickRegionId = regionId;
        vm.clickRegionDeviceType = type;
        vm.curOpenModalBindDevices = {
          type: type,
          name: vm.$strTool.filterSwitchType(type),
          devCount: 0,
          deviceViews: []
        };
        vm.isShowModal = true;
      },
      // 点击删设备绑定关系
      onclickDelItem: function onclickDelItem(index) {
        var vm = this;
        var device = vm.curOpenModalBindDevices.deviceViews[index]; // 分组类型（设备 type 是产品型号）

        var policyType = device.rasPolicyType != null ? device.rasPolicyType : vm.curOpenModalBindDevices.type;

        _dialog.default.confirm({
          title: '提示',
          message: '删除为不可逆操作，您确定要删除该设备吗？'
        }).then(function (res) {
          console.log(res);

          if (vm.__MOCK_STATUS) {
            var areaDetail = mockJson.rasAreaDetailMap[vm.clickRegionId];
            var group = areaDetail && areaDetail.policyDeviceViews.filter(function (item) {
              return item.type == device.type;
            })[0];

            if (group) {
              group.deviceViews = (group.deviceViews || []).filter(function (item) {
                return item.uniqueId !== device.uniqueId;
              });
              group.devCount = group.deviceViews.length;
              group.runningCount = Math.min(group.runningCount, group.devCount);
              group.warnCount = Math.min(group.warnCount || 0, group.devCount);
            }

            vm.curOpenModalBindDevices.deviceViews.splice(index, 1);
            vm.curOpenModalBindDevices.deviceViews = [].concat(vm.curOpenModalBindDevices.deviceViews);

            _dialog.default.alert({
              title: '提示',
              message: '操作成功'
            });

            vm.init();
            return;
          }

          vm.$http({
            type: "delete",
            // 总览弹窗里的设备用其自身 rasAreaId
            url: "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasDevice/bind?rasAreaId=").concat(device.rasAreaId || vm.clickRegionId, "&type=").concat(policyType, "&uniqueId=").concat(device.uniqueId)
          }).then(function (res) {
            if (res.code == 1) {
              _dialog.default.alert({
                title: '提示',
                message: '操作成功'
              });

              vm.curOpenModalBindDevices.deviceViews.splice(index, 1);
              vm.curOpenModalBindDevices.deviceViews = [].concat(vm.curOpenModalBindDevices.deviceViews);
              vm.refreshAfterDeviceChange();
            }
          }).catch(function (err) {
            console.log(err);
          });
        });
      },
      // 点击编辑设备信息
      oncllickCtrlItem: function oncllickCtrlItem(index) {
        var vm = this;
        var device = vm.curOpenModalBindDevices.deviceViews[index];
        var policyType = device.rasPolicyType != null ? device.rasPolicyType : vm.curOpenModalBindDevices.type;
        var deviceInfo = {
          type: policyType,
          uniqueId: device.uniqueId,
          name: device.name,
          workType: device.workType,
          power: device.powerRate,
          rasAreaId: device.rasAreaId || vm.clickRegionId,
          isEdit: true
        };
        deviceInfo.workType == 1 && (deviceInfo.workType = '220V');
        deviceInfo.workType == 2 && (deviceInfo.workType = '380V');
        vm.deviceInfo = deviceInfo;
        vm.isShowEditModal = true;
        vm.editIndex = index;
      },
      onclickAddDeviceBtn: function onclickAddDeviceBtn() {
        var vm = this;
        vm.deviceInfo = {
          type: vm.clickRegionDeviceType
        };
        vm.isShowEditModal = true;
      },
      // 选择功率
      onSelectWorkType: function onSelectWorkType(workType) {
        var vm = this;
        vm.deviceInfo.workType = workType;
        vm.isShowWorkTypeList = false;
      },
      // 点击保存添加的设备信息
      onclickSaveBtn: function onclickSaveBtn() {
        var vm = this;
        var _vm$deviceInfo = vm.deviceInfo,
            uniqueId = _vm$deviceInfo.uniqueId,
            name = _vm$deviceInfo.name,
            workType = _vm$deviceInfo.workType,
            power = _vm$deviceInfo.power,
            type = _vm$deviceInfo.type,
            isEdit = _vm$deviceInfo.isEdit;
        var err = ''; // 编辑时用设备自身分组，新增时绑定到当前操作的分组

        var rasAreaId = isEdit && vm.deviceInfo.rasAreaId ? vm.deviceInfo.rasAreaId : vm.clickRegionId;
        var data = {
          uniqueId: uniqueId,
          name: name,
          type: type,
          rasAreaId: rasAreaId
        };

        if (!("".concat(uniqueId).length == 8 && Number(uniqueId) > 0)) {
          err = '请输入正确的八位设备编号';
        } // 溶氧与投料机免填进线方式、功率


        if (type != 8 && type != 9) {
          if (!workType) {
            err = '请选择进线方式';
          }

          if (!power) {
            err = '请填写功率';
          }
        } // 已有值一并提交


        if (type != 8 && (power || workType)) {
          data.powerRate = power;
          data.workType = workType == '220V' ? 1 : 2;
        }

        if (err) {
          _dialog.default.alert({
            title: '提示',
            message: err
          });

          return;
        } // 本地 mock：直接操作本地数据


        if (vm.__MOCK_STATUS) {
          var areaDetail = mockJson.rasAreaDetailMap[vm.clickRegionId];
          var group = areaDetail && areaDetail.policyDeviceViews.filter(function (item) {
            return item.type == type;
          })[0];

          if (group) {
            if (isEdit) {
              var device = (group.deviceViews || []).find(function (item) {
                return item.uniqueId === uniqueId;
              });
              device && Object.assign(device, {
                name: data.name,
                powerRate: data.powerRate,
                workType: data.workType
              });
            } else {
              group.deviceViews = group.deviceViews || [];

              if (type == 8 && !data.name) {
                data.name = "".concat(group.deviceViews.length + 1, "\u53F7\u6876");
              }

              group.deviceViews = group.deviceViews.concat([Object.assign({
                dissolvedOxygen: 5.0,
                depth: 1.3,
                minOxygen: 5,
                status: 1,
                warningType: 0
              }, data)]);
              group.devCount = group.deviceViews.length;
              group.runningCount = group.deviceViews.length;
            } // 刷新已打开的设备列表弹窗


            if (vm.isShowModal) {
              vm.curOpenModalBindDevices = vm.$strTool.copy(group);
            }
          }

          _dialog.default.alert({
            title: '',
            message: '保存成功'
          });

          vm.isShowEditModal = false;
          vm.init();
          return;
        } // 溶氧仪改名走专用接口


        if (isEdit && type == 8) {
          vm.$http({
            type: "put",
            url: "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasDevice/ryName"),
            data: {
              name: name,
              rasAreaId: rasAreaId,
              uniqueId: uniqueId
            }
          }).then(function (res) {
            if (res.code == 1) {
              vm.curOpenModalBindDevices.deviceViews[vm.editIndex].name = data.name;

              _dialog.default.alert({
                title: '',
                message: '保存成功'
              });

              vm.isShowEditModal = false;
              vm.refreshAfterDeviceChange();
            }
          }).catch(function (err) {
            console.log(err);
          });
          return;
        } // 编辑 / 新绑定


        var url = "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasDevice/manage");

        if (!isEdit) {
          url = "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasDevice/bind");
          data.type = vm.clickRegionDeviceType;
        }

        vm.$http({
          type: "post",
          url: url,
          data: data
        }).then(function (res) {
          if (res.code == 1) {
            if (isEdit) {
              vm.curOpenModalBindDevices.deviceViews[vm.editIndex].name = data.name;
              vm.curOpenModalBindDevices.deviceViews[vm.editIndex].powerRate = data.powerRate;
              vm.curOpenModalBindDevices.deviceViews[vm.editIndex].workType = data.workType;
            } else {
              vm.curOpenModalBindDevices.deviceViews = vm.curOpenModalBindDevices.deviceViews.concat([data]);
            }

            _dialog.default.alert({
              title: '',
              message: '保存成功'
            });

            vm.isShowEditModal = false;
            vm.refreshAfterDeviceChange();
          }
        }).catch(function (err) {
          console.log(err);
        });
      },
      // 设备变更后刷新基地信息与页面数据
      refreshAfterDeviceChange: function refreshAfterDeviceChange() {
        var vm = this;

        if (vm.__MOCK_STATUS) {
          vm.init();
          vm.refreshRyModalList();
          return;
        }

        vm.$http({
          type: "post",
          url: "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasDevice/reinit?rasId=").concat(vm.rasId),
          except: true
        }).then(function () {
          vm.init();
          vm.loadEnergyFeed();
          vm.refreshRyModalList();
        }).catch(function (err) {
          console.log(err);
          vm.init();
          vm.refreshRyModalList();
        });
      },
      // 刷新溶氧弹框设备列表
      refreshRyModalList: function refreshRyModalList() {
        var vm = this;
        vm.isShowModal && vm.clickRegionDeviceType == 8 && vm.loadRegionInfo(8, vm.clickRegionId);
      },
      // 设备行图标（投料机用专用图标）
      deviceIcon: function deviceIcon(type) {
        if (type == 9) {
          return 'https://static.yudada.com/wechat/pond/img/fedder_wind_icon.png';
        }

        return "".concat(this.ossHost, "img/ras-dev-").concat(type + 1, ".png");
      },
      // 获取设备配置信息（0循环泵，8溶氧告警）
      loadDeviceSetting: function loadDeviceSetting(type, id) {
        var vm = this;

        if (vm.__MOCK_STATUS) {
          vm.deviceSettingInfo = type == 8 ? {
            type: 8,
            status: 1,
            minOxygen: 5
          } : {
            type: 0,
            status: 1,
            lbDurationSec: 7200
          };
          return;
        }

        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasArea/").concat(id, "/deviceConfig?type=").concat(type)
        }).then(function (res) {
          vm.deviceSettingInfo = res.data;
          console.log(res);
        }).catch(function (err) {
          console.log(err);
        });
      },
      // 编辑设备设置信息type：0循环泵，8溶氧。index：-1打开跟关闭操作，其他情况设置时长或者低溶氧
      onSelectSetting: function onSelectSetting(type, index) {
        var vm = this;
        var data = vm.$strTool.copy(vm.deviceSettingInfo);
        data.type = type;

        if (index == -1) {
          data.status = Number(!vm.deviceSettingInfo.status);
        }

        if (type == 8) {
          data.lowOxygen = index > -1 ? index : data.minOxygen;
          delete data.minOxygen;
          delete data.minOxygenPre;
          delete data.lbDurationSec; // 不传 rasColumnId 表示全量修改所有圆桶

          delete data.rasColumnId;
        }

        if (!type) {
          if (index > -1) {
            data.lbDurationSec = index * 3600;
          }

          delete data.lowOxygen;
          delete data.minOxygen;
          delete data.minOxygenPre;
        }

        if (vm.__MOCK_STATUS) {
          // 本地 mock：直接更新本地配置
          data.lowOxygen && (data.minOxygen = data.lowOxygen);
          vm.deviceSettingInfo = data;

          _dialog.default.alert({
            title: '',
            message: '操作成功'
          });

          vm.init();
          return;
        }

        vm.$http({
          type: "put",
          url: "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasArea/").concat(vm.clickRegionId, "/deviceConfig"),
          data: data
        }).then(function (res) {
          if (res.code == 1) {
            _dialog.default.alert({
              title: '',
              message: '操作成功'
            });

            data.lowOxygen && (data.minOxygen = data.lowOxygen);
            vm.deviceSettingInfo = data;
            console.log(vm.deviceSettingInfo);
            vm.loadRegionList();
          } // vm.deviceSettingInfo = res.data


          console.log(res);
        }).catch(function (err) {
          console.log(err);
        });
      },
      // 打开水位告警值设置弹框
      onclickWLValItem: function onclickWLValItem(field) {
        var vm = this;
        var key = field == 'high' ? 'cbmWLHighWarningVal' : 'cbmWLLowWarningVal';
        vm.wlValField = field;
        vm.wlValInput = vm.deviceSettingInfo[key] == null ? '' : String(vm.deviceSettingInfo[key]);
        vm.isShowWLValModal = true;
      },
      // 取消水位告警值设置
      onCancelWLValModal: function onCancelWLValModal() {
        this.isShowWLValModal = false;
      },
      // 确认水位告警值：校验通过后提交接口
      onConfirmWLValModal: function onConfirmWLValModal() {
        var vm = this;
        var val = Number(vm.wlValInput);

        if (!(val > 0)) {
          _dialog.default.alert({
            title: '提示',
            message: '请输入正确的水位告警值'
          });

          return;
        }

        var key = vm.wlValField == 'high' ? 'cbmWLHighWarningVal' : 'cbmWLLowWarningVal';
        vm.deviceSettingInfo[key] = val;
        vm.isShowWLValModal = false;
        vm.onSelectCbmWLSetting(vm.wlValField);
      },
      // 水位告警配置提交（index=-1 切开关）
      onSelectCbmWLSetting: function onSelectCbmWLSetting(field, index) {
        var vm = this;
        var data = vm.$strTool.copy(vm.deviceSettingInfo);
        data.type = 8; // 随水位配置一起提交当前溶氧告警值

        data.lowOxygen = data.minOxygen;
        delete data.minOxygen;
        delete data.minOxygenPre;
        delete data.lbDurationSec; // 不传 rasColumnId 表示全量修改所有圆桶

        delete data.rasColumnId;

        if (index == -1) {
          if (field == 'high') {
            data.cbmWLHighWarning = !vm.deviceSettingInfo.cbmWLHighWarning;
          }

          if (field == 'low') {
            data.cbmWLLowWarning = !vm.deviceSettingInfo.cbmWLLowWarning;
          }
        }

        if (vm.__MOCK_STATUS) {
          // 本地 mock：直接更新本地配置
          data.lowOxygen && (data.minOxygen = data.lowOxygen);
          vm.deviceSettingInfo = data;

          _dialog.default.alert({
            title: '',
            message: '操作成功'
          });

          vm.init();
          return;
        }

        vm.$http({
          type: "put",
          url: "".concat(vm.$config.base.ADMIN_URL, "rasProgram/rasArea/").concat(vm.clickRegionId, "/deviceConfig"),
          data: data
        }).then(function (res) {
          if (res.code == 1) {
            _dialog.default.alert({
              title: '',
              message: '操作成功'
            });

            data.lowOxygen && (data.minOxygen = data.lowOxygen);
            vm.deviceSettingInfo = data;
            vm.loadRegionList();
          }
        }).catch(function (err) {
          console.log(err);
        });
      },
      // ==================== 底部图表（每日投料 / 每日用电） ====================
      initEnergyChart: function initEnergyChart() {
        var vm = this;
        var chartDom = document.getElementById('energy-chart');
        if (!chartDom) return;
        vm.energyChart = vm.energyChart || vm.$echarts.init(chartDom);
        var _vm$energyFeed = vm.energyFeed,
            days = _vm$energyFeed.days,
            feedData = _vm$energyFeed.feedData,
            electricityData = _vm$energyFeed.electricityData;
        var axisLabel = {
          color: '#fff',
          fontSize: 12
        };
        vm.energyChart.setOption({
          grid: {
            left: '7%',
            right: '3%',
            bottom: '10%',
            top: '30%'
          },
          legend: {
            right: '2%',
            top: '4%',
            icon: 'roundRect',
            itemWidth: 10,
            itemHeight: 6,
            textStyle: {
              color: '#fff',
              fontSize: 12
            },
            data: ['每日投料', '每日用电']
          },
          tooltip: {
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: days || [],
            axisLabel: Object.assign({
              interval: 1
            }, axisLabel),
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.15)',
                type: 'dashed'
              }
            }
          },
          yAxis: {
            type: 'value',
            min: 0,
            splitNumber: 2,
            axisLabel: Object.assign({}, axisLabel),
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)'
              }
            }
          },
          series: [{
            name: '每日投料',
            type: 'line',
            smooth: true,
            symbol: 'none',
            data: feedData || [],
            itemStyle: {
              color: '#F1BE69'
            },
            lineStyle: {
              width: 2
            },
            areaStyle: {
              color: new vm.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(241, 190, 105, 0.4)'
              }, {
                offset: 1,
                color: 'rgba(241, 190, 105, 0)'
              }])
            }
          }, {
            name: '每日用电',
            type: 'line',
            smooth: true,
            symbol: 'none',
            data: electricityData || [],
            itemStyle: {
              color: '#8CFFE9'
            },
            lineStyle: {
              width: 2
            },
            areaStyle: {
              color: new vm.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(140, 255, 233, 0.4)'
              }, {
                offset: 1,
                color: 'rgba(140, 255, 233, 0)'
              }])
            }
          }]
        });
      },
      handleResize: function handleResize() {
        var vm = this; // 重绘echarts

        vm.energyChart && vm.energyChart.resize();
      }
    }
  };
  _exports.default = _default;
});